import React from 'react';
import { Divider } from '@mui/material';

const DividerBlock: React.FC = () => {
  return <Divider sx={{ my: 1 }} />;
};

export default DividerBlock;
